export function isCompanionAppVersionFormatValid(
  enteredVersion: string,
  requiredMinimumVersion: string
): boolean {
  const normalize = (v: string): number[] => {
    const parts = v.split('.').map(Number);
    while (parts.length < 5) parts.push(0);
    return parts.slice(0, 5);
  };

  const entered = normalize(enteredVersion);
  const required = normalize(requiredMinimumVersion);

  for (let i = 0; i < 5; i++) {
    if (entered[i] > required[i]) return true;
    if (entered[i] < required[i]) return false;
  }

  return true;
}